<template>
  <div :class="['add-edit-contact-modal', modalContentClass]">
    <b-tabs class="contact-tabs gk-tabs">
      <overlay-scrollbars :options="{ scrollbars: { autoHide: 'never' }, overflowBehavior: { y: 'scroll', x: 'hidden' } }">
        <b-tab :title="$gettext('Details')" active>
          <ContactForm
              ref="contactform"
              :contactId="contactId"
              :contact="contactDetails"
              @created="onContactCreated"
              @updated="onContactUpdated"/>
        </b-tab>

        <b-tab v-if="contactId" :title="$gettext('Documents')" class="m-3">
          <b-card-text>
            <DocumentList />
          </b-card-text>
        </b-tab>
      </overlay-scrollbars>
    </b-tabs>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import DocumentList from "@/components/contacts/DocumentList";
import ContactForm from "@/components/contacts/ContactForm.vue";
import CustomerService from "@/store/services/customer.service";

export default {
  name: "AddEditContact",
  components: {DocumentList, ContactForm},
  props: {
    contactDetails: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      contactId: null
    }
  },
  computed: {
    ...mapGetters({
      currentCompany: "main/getCurrentCompany",
      preferredLanguage: 'main/getPreferredLanguage',
      getCompanyId: 'main/getCompanyId'
    }),
    getKvkLabelText() {
      if (this.contactDetails.country === "ES")
        return this.$gettext("NIF-IVA number");
      else if (this.contactDetails.country === "BE")
        return this.$gettext("KBO number");
      else
        return this.$gettext("KvK number");
    },
    modalContentClass() {
      if (this.contactId)
        return "contact-modal-content";
      else
        return "contact-modal-content-tabs-hidden";
    },
    showImportButton() {
      return !this.contactDetails.kvk.length && this.currentCompany.country === "NL" && this.contactDetails.name.length > 2; // 3 characters required to show button
    },
    isYourCompany() {
      return parseInt(this.$route.params['contactId']) === parseInt(this.getCompanyId)
    }
  },
  created() {
    this.contactId = this.$route.params['contactId'] ? parseInt(this.$route.params['contactId']) : null;
  },
  methods: {
    saveForm() {
      this.$refs.contactform.saveForm();
    },
    onContactCreated(contactObj) {
      this.$emit('created', contactObj);
    },
    onContactUpdated(contactObj) {
      this.$emit('updated', contactObj);
    }
  }
}
</script>

<style lang="scss" scoped>
.tab-form {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
</style>
